import { SelectDos } from "../plugins/select2";
import { getData, CSRF } from "../helpers";

/**
 * Implementar el plugin Select2 para las empresas
 *
 */
export class SelectTag extends HTMLSelectElement {
    connectedCallback() {
        let configSelect = {
            ajax: {
                url: getData("tagsUrlSelect"),
                type: "post",
                dataType: "json",
                cache: true,
                data: function (param) {
                    return {
                        _token: CSRF,
                        search: param.term,
                        // limit: 10,
                    };
                },
                processResults: function (response) {
                    // response.forEach((element) => {
                    //     element.id = element.alpha2;
                    // });
                    return {
                        results: response,
                    };
                },
            },
            // templateResult: (data) => ucwords(data.text),
            // templateSelection: (data) => {
            //     if (!data.id) {
            //         return data.text;
            //     }
            //     return `${data.alpha2}`;
            // },
        };

        const SD = new SelectDos(configSelect);
        SD.selectDos(this);
    }

    reset() {
        // this.dataS.notIn = [];
    }
}

window.customElements.define("select-tag", SelectTag, {
    extends: "select",
});
